import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from '../api/geography.api';
import { GEOGRAPHY_KEYS } from './geography.keys';

/** Near-static (250 rows, ~35KB) - long staleTime, prefetched (see prefetchGeography). */
const STALE_TIME_MS = 24 * 60 * 60 * 1000;

export function useCountries() {
  return useQuery({
    queryKey: GEOGRAPHY_KEYS.countries,
    queryFn: fetchCountries,
    staleTime: STALE_TIME_MS,
  });
}
